import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type OrderIdDropdownQueryVariables = {
  validOnly?: Types.Maybe<Types.Scalars['Boolean']>
};


export type OrderIdDropdownQuery = (
  { __typename?: 'Query' }
  & { orderIds: Array<(
    { __typename?: 'OrderId' }
    & Pick<Types.OrderId, '_id' | 'value'>
  )> }
);

export const OrderIdDropdownDocument = gql`
    query OrderIdDropdown($validOnly: Boolean = true) {
  orderIds(validOnly: $validOnly) {
    _id
    value
  }
}
    `;

    export function useOrderIdDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrderIdDropdownQuery, OrderIdDropdownQueryVariables>) {
      return ApolloReactHooks.useQuery<OrderIdDropdownQuery, OrderIdDropdownQueryVariables>(OrderIdDropdownDocument, baseOptions);
    };
      export function useOrderIdDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderIdDropdownQuery, OrderIdDropdownQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<OrderIdDropdownQuery, OrderIdDropdownQueryVariables>(OrderIdDropdownDocument, baseOptions);
      };
      
export type OrderIdDropdownQueryHookResult = ReturnType<typeof useOrderIdDropdownQuery>;
export type OrderIdDropdownQueryResult = ApolloReactCommon.QueryResult<OrderIdDropdownQuery, OrderIdDropdownQueryVariables>;